import { useHistory, useLocation } from 'react-router'

import { Types } from '@tribeplatform/gql-client'
import {
  SystemSpaceSlug,
  useAuthToken,
  useSpaceUtil,
} from '@tribeplatform/react-sdk/hooks'

export const useLogin = () => {
  const { data: authToken } = useAuthToken()
  const isGuest =
    !authToken?.role?.type || authToken?.role?.type === Types.RoleType.GUEST
  const location = useLocation()
  const { push } = useHistory()
  const { generatePath } = useSpaceUtil()

  const showLogin = () => {
    if (!isGuest) return false
    push(
      generatePath(
        SystemSpaceSlug.LOGIN,
        null,
        location?.pathname
          ? { redirect: encodeURIComponent(location.pathname) }
          : null,
      ),
    )
  }

  const isLoggedIn = !isGuest

  return {
    showLogin,
    isLoggedIn,
  }
}
